import {createSelector} from 'reselect';
import MessageType from '../../../../enums/MessageType';
import {generateBooleanSelector} from '../../SelectorGenerator';
import {deliveryCountryOrderCurrencyMatch} from '../PaymentOptionSelectors';

export const getAfterpayClearpayErrorMessage = createSelector(
  [deliveryCountryOrderCurrencyMatch],
  (deliveryCountryOrderCurrencyMatch) => {
    if (!deliveryCountryOrderCurrencyMatch) {
      return {type: MessageType.INFO, translationKey: 'klarna.payments.ineligible.message'};
    }

    return null;
  },
);

export const getAfterpayClearpayIsDisabled = generateBooleanSelector(getAfterpayClearpayErrorMessage);
